import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

export default function AccountReadiness({ profile, catalog, onChange }) {
  const [accepted, setAccepted] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const run = async (fn) => {
    setBusy(true); setError(''); setNotice('');
    try { await fn(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  const acceptedCurrent=profile&&profile.version===catalog.version&&profile.terms_version===catalog.terms_version&&profile.privacy_version===catalog.privacy_version;
  if (acceptedCurrent&&profile.email_verified) return <p className="af-note">Correo verificado. Puedes continuar con tu solicitud.</p>;
  return <section className="af-card" aria-label="Preparar cuenta">
    <h2>{profile ? 'Verifica tu correo' : 'Prepara tu cuenta'}</h2>
    <p>Conservamos aquí tu expediente. Verifica tu correo antes de iniciar un pago.</p>
    {!acceptedCurrent ? <form onSubmit={e => { e.preventDefault(); run(async () => {
      await api.post('/auth/commercial-acceptance', { commercial_version:catalog.version,
        terms_privacy_accepted:accepted, terms_version:catalog.terms_version,
        privacy_version:catalog.privacy_version, marketing_opt_in:marketing }); await onChange();
    }); }}>
      <label className="af-check"><input type="checkbox" required checked={accepted} onChange={e=>setAccepted(e.target.checked)} /><span>Acepto los <Link to="/terminos" target="_blank">términos</Link> y el <Link to="/aviso-privacidad" target="_blank">aviso de privacidad</Link>.</span></label>
      <label className="af-check"><input type="checkbox" checked={marketing} onChange={e=>setMarketing(e.target.checked)} />Deseo recibir novedades y comunicaciones comerciales (opcional).</label>
      <button className="af-button" disabled={busy || !catalog}>Guardar aceptación</button>
    </form> : <>
      <button type="button" className="af-button secondary" disabled={busy} onClick={()=>run(async()=>{
        const {data}=await api.post('/auth/commercial-contact/send-code',{});
        if(data.already_verified) await onChange(); else setNotice('Código enviado. Revisa tu correo y la carpeta de correo no deseado.');
      })}>Enviar código a mi correo</button>
      <form onSubmit={e=>{e.preventDefault();run(async()=>{
        await api.post('/auth/commercial-contact/verify',{code}); await onChange();
      });}}>
        <label className="af-label" htmlFor="contact-code">Código de seis dígitos</label>
        <input id="contact-code" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={code} onChange={e=>setCode(e.target.value)} />
        <div className="af-actions"><button className="af-button" disabled={busy}>Verificar correo</button></div>
      </form>
    </>}
    {error && <p className="af-error" role="alert">{error}</p>}{notice && <p className="af-note" role="status">{notice}</p>}
  </section>;
}
